import { render, staticRenderFns } from "./SwitchTheme.vue?vue&type=template&id=814c0864"
import script from "./SwitchTheme.vue?vue&type=script&lang=js"
export * from "./SwitchTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports